<template>
    <svg enable-background="new 0 0 48 48" version="1.1" viewBox="0 0 48 48" xml:space="preserve" width="12" height="12"
         xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g><path d="M24,0C10.745,0,0,10.745,0,24s10.745,24,24,24s24-10.745,24-24S37.255,0,24,0z M24,44   C12.954,44,4,35.046,4,24S12.954,4,24,4s20,8.954,20,20S35.046,44,24,44z"/><polygon
            points="26,22 22,22 18.042,22 13,22 13,26 18.833,26 22,26 26,26 29.625,26 35,26 35,22 29.709,22  "/></g></svg>
</template>
